import { render, staticRenderFns } from "./87.vue?vue&type=template&id=6fbf41d4&scoped=true&"
import script from "./87.vue?vue&type=script&lang=js&"
export * from "./87.vue?vue&type=script&lang=js&"
import style0 from "./87.vue?vue&type=style&index=0&id=6fbf41d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbf41d4",
  null
  
)

export default component.exports